import { CarbonIntensityEnv } from '@belimo-retrofit-portal/logic';
import { createSelector } from 'reselect';
import { getCarbonIntensityState } from 'src/modules/carbon-intensity/selectors/getCarbonIntensityState';
import { getHvacCountryCode } from 'src/modules/hvac/selectors/getHvacCountryCode';
import { assertNotEmpty } from 'src/utils/assert';

export const getHvacCarbonIntensityEnv = createSelector([
  getHvacCountryCode,
  getCarbonIntensityState,
], (country, carbonIntensity): CarbonIntensityEnv => ({
  carbonIntensityOfElectricity: assertNotEmpty(
    carbonIntensity.get(country),
    `No carbon intensity data for "${country}"`,
    { carbonIntensity },
  ).value,
}));
